export async function updateIntroProgress({ token, userId, introComplete, countries = [] }) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/updateIntroProgress`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      userId,
      introComplete,
      countries,
    }),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok || !data.success) {
    throw new Error(data.message || 'Failed to update intro progress');
  }
  return data;
}

export function parseIntroComplete(reportRow) {
  if (!reportRow) return false;
  return String(reportRow.intro_countries ?? '').trim() !== '';
}

function stageAnswerColumn(stageNumber) {
  switch (stageNumber) {
    case 1:
      return 'stage1_ans';
    case 2:
      return 'stage2_ans';
    case 3:
      return 'infrastructure';
    case 4:
      return 'stage3_ans';
    case 5:
      return 'stage4_ans';
    case 6:
      return 'stage5_ans';
    case 7:
      return 'svg_files';
    default:
      return null;
  }
}

export function getStageAnswerPlayed(reportRow, stageNumber) {
  if (!reportRow || !stageNumber) return false;
  if (stageNumber === 3) {
    return (
      String(reportRow.infrastructure ?? '').trim() !== '' ||
      String(reportRow.predicted_gdp ?? '').trim() !== ''
    );
  }
  const col = stageAnswerColumn(stageNumber);
  if (!col) return false;
  return String(reportRow[col] ?? '').trim() !== '';
}

export function getCurrentFutureStage(reportRow) {
  if (!parseIntroComplete(reportRow)) return 'intro';
  for (let i = 1; i <= 7; i++) {
    if (!getStageAnswerPlayed(reportRow, i)) return `stage_${i}`;
  }
  return 'thankyou';
}
